import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

// General icons
import { FaHome, FaInfoCircle, FaTools, FaPhoneAlt } from 'react-icons/fa';

// Appliance-specific icons
import { MdOutlineLiveTv, MdOutlineAcUnit, MdOutlineKitchen } from 'react-icons/md';
import { GiWashingMachine } from 'react-icons/gi';
import { MdMicrowave } from 'react-icons/md';

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-white bg-white shadow-sm">
      <div className="container">

        {/* Brand Name */}
        <Link className="navbar-brand fw-bold text-dark me-auto" to="/">
          Home Appliance Assist
        </Link>

        <button className="navbar-toggler mx-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav black-bar px-4 py-2 rounded">
            <li className="nav-item px-3">
              <Link className="nav-link d-flex align-items-center gap-2" to="/">
                <FaHome /> Home
              </Link>
            </li>
            <li className="nav-item px-3">
              <Link className="nav-link d-flex align-items-center gap-2" to="/about">
                <FaInfoCircle /> About
              </Link>
            </li>
            <li className="nav-item dropdown px-3">
              <span className="nav-link dropdown-toggle d-flex align-items-center gap-2" role="button" data-bs-toggle="dropdown">
                <FaTools /> Services
              </span>
              <ul className="dropdown-menu dropdown-menu-center animate-dropdown">
                <li>
                  <Link className="dropdown-item" to="/ac-service">
                    <MdOutlineAcUnit className="glow-icon" /> AC Service
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/tv-service">
                    <MdOutlineLiveTv className="glow-icon" /> TV Service
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/fridge-service">
                    <MdOutlineKitchen className="glow-icon" /> Fridge Service
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/washing-machine-service">
                    <GiWashingMachine className="glow-icon" /> Washing Machine Service
                  </Link>
                </li>
                <li>
  <Link className="dropdown-item" to="/Micro">
    <MdMicrowave className="glow-icon" /> Microwave Oven Service
  </Link>
</li>

              </ul>
            </li>
            <li className="nav-item px-3">
              <Link className="nav-link d-flex align-items-center gap-2" to="/contact">
                <FaPhoneAlt /> Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
